import { render, staticRenderFns } from "./ConfiguracionRemitos.vue?vue&type=template&id=db60ff52&scoped=true"
import script from "./ConfiguracionRemitos.vue?vue&type=script&lang=js"
export * from "./ConfiguracionRemitos.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionRemitos.vue?vue&type=style&index=0&id=db60ff52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db60ff52",
  null
  
)

export default component.exports